import type React from "react"
import type { PromptState, PromptType } from "."
import { Prompt } from "./Prompt"

interface PromptContainerProps {
  prompts: PromptType<any, PromptState>[]
}

export const PromptContainer: React.FC<PromptContainerProps> = ({
  prompts,
}) => {
  return (
    <>
      {prompts.map((prompt) => (
        <Prompt key={prompt.id} prompt={prompt} />
      ))}
    </>
  )
}
